import { AxiosResponse } from "axios";
import { call, put } from "redux-saga/effects";
import api from "../../Axios/middleware";
import { PayloadAction } from "@reduxjs/toolkit";
import {
    failurelistVideoTutorials,
    successlistVideoTutorials,
} from "./ListVideoTutorialsSlice";
import { failureaddVideoTutorial, successaddVideoTutorial } from "./AddVideoTutorialSlice";
import { failureeditVideoTutorial, successeditVideoTutorial } from "./EditVideoTutorialSlice";
import { failuredeleteVideoTutorial, successdeleteVideoTutorial } from "./DeleteVideoTutorialSlice";
import { IVideoTutorial } from "../../../Pages/VideoPage/IVideoTutorial";

const ListVideoTutorialsApi = (action: PayloadAction<any>) => {
    return api.get("/api/videoTutorials/", {
        params: action.payload,
    });
};

export function* ListVideoTutorialsCall(action: PayloadAction<any>) {
    try {
        const response: AxiosResponse = yield call(ListVideoTutorialsApi, action);
        yield put(successlistVideoTutorials(response.data));
    } catch (error) {
        yield put(failurelistVideoTutorials(error));
    }
}

// add
const AddVideoTutorialApi = (action: PayloadAction<IVideoTutorial>) => {
    return api.post("/api/videoTutorials/", action.payload);
};

export function* AddVideoTutorialCall(action: PayloadAction<IVideoTutorial>) {
    try {
        const response: AxiosResponse = yield call(AddVideoTutorialApi, action);
        yield put(successaddVideoTutorial(response.data));
    } catch (error) {
        yield put(failureaddVideoTutorial(error));
    }
}

// edit
const EditVideoTutorialApi = (action: PayloadAction<IVideoTutorial>) => {
    return api.post("/api/videoTutorials/", action.payload);
};

export function* EditVideoTutorialCall(action: PayloadAction<IVideoTutorial>) {
    try {
        const response: AxiosResponse = yield call(EditVideoTutorialApi, action);
        yield put(successeditVideoTutorial(response.data));
    } catch (error) {
        yield put(failureeditVideoTutorial(error));
    }
}

// delete
const DeleteVideoTutorialApi = (action: PayloadAction<any>) => {
    return api.post("/api/videoTutorials/", action.payload);
};

export function* DeleteVideoTutorialCall(action: PayloadAction<any>) {
    try {
        const response: AxiosResponse = yield call(DeleteVideoTutorialApi, action);
        yield put(successdeleteVideoTutorial(response.data));
    } catch (error) {
        yield put(failuredeleteVideoTutorial(error));
    }
}
